<template>
  <div class="drag-sort-container">
    <div
      v-for="(item, index) in localList"
      v-show="((type == 1 && !item.hiddenByDefault) || (type == 2 && item.hiddenByDefault)) && !item.searchShow"
      :key="item.key || item.id || index"
      class="drag-item"
      :class="[
        {
          'dragging': draggingIndex === index,
          'drag-ghost': isDragging && draggingIndex === index,
        },
        'item',
        type == 1 ? '' : 'pre',
      ]"
      draggable="true"
      @dragstart="handleDragStart(index, $event)"
      @dragover.prevent
      @dragenter="handleDragEnter(index)"
      @dragend="handleDragEnd"
    >
      <svg
        v-if="type == 1 && search == '' && !item.fixed"
        class="iconfont souding"
        t="1764054262899"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="6644"
        width="16"
        height="16"
      >
        <path
          d="M344 132c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m70 380c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m336 0c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70zM344 752c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m406 70c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m0-620c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z"
          fill="#323338"
          p-id="6645"
        />
      </svg>
      <div
        class="label"
        draggable="false"
        @mousedown.prevent
      >
        {{ item.title }}
      </div>
      <div
        v-show="!item.fixed"
        class="icon"
        draggable="false"
        @mousedown.prevent
        @click="statusShowFn(item)"
      >
        <el-icon><Close /></el-icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Close } from '@element-plus/icons-vue';
import { ref, watch } from 'vue';
// 定义 Props
const props = defineProps({
  list: {
    type: Array,
    required: true,
  },
  sort: {
    type: Boolean,
    default: false,
  },
  type: {
    type: Number,
    default: 1, // 1:展示 2:不展示
    validator: (val) => [1, 2].includes(val),
  },
  search: {
    type: String,
    default: '',
  },
});

// 定义响应式数据（替代Vue2的data）
const localList = ref(JSON.parse(JSON.stringify(props.list)));
watch(
  () => props.list,
  (list) => {
    localList.value = JSON.parse(JSON.stringify(list));
  },
  { deep: true },
);
const draggingIndex = ref(-1);
const dragOverIndex = ref(-1);
const isDragging = ref(false);
const emit = defineEmits(['update', 'update:list', 'del']);
// 监听搜索文本变化（Vue3 版本）
watch(
  () => props.search, // 监听的源：props 中的 search
  (value) => {
    // 遍历列表项，根据搜索值设置显示状态
    localList.value.forEach((item) => {
      // 检查标签是否包含搜索值（不区分大小写可添加 .toLowerCase()）
      item.searchShow = item.label.indexOf(value) === -1;
    });

    // Vue3 响应式系统会自动更新，无需 forceUpdate
  },
  { immediate: true }, // 初始化时立即执行一次
); // 监听搜索文本变化（Vue3 版本）

function statusShowFn(item) {
  emit('del', item);
}

const handleDragStart = (index, event) => {
  // 阻止特定元素触发拖拽（标签或图标元素）
  if (event.target.classList.contains('label') || event.target.classList.contains('icon')) {
    // 若是指定元素，直接阻止拖拽逻辑
    event.preventDefault();
    return;
  }

  // 更新拖拽状态
  draggingIndex.value = index;
  isDragging.value = true;

  const item = event.target.closest('.drag-item');

  // 禁用拖拽元素的过渡效果
  item.classList.add('no-transition');

  // 添加拖拽样式（使用setTimeout确保样式生效）
  window.setTimeout(() => {
    item.classList.add('drag-ghost');
  }, 0);
};

function handleDragEnter(index) {
  if (draggingIndex.value === -1 || index === draggingIndex.value || props.list[index].fixed) return; // false:下移
  // 记录当前拖拽位置
  const fromIndex = draggingIndex.value;
  moveItem(fromIndex, index);
  // 执行列表重排
  dragOverIndex.value = index;

  draggingIndex.value = index;
  // 拖拽位置更新后由 Vue 响应式系统同步列表视图。
}

function handleDragEnd() {
  isDragging.value = false;
  draggingIndex.value = -1;
  dragOverIndex.value = -1;

  // 移除所有临时样式
  document.querySelectorAll('.drag-item').forEach((item) => {
    item.classList.remove('drag-ghost', 'no-transition', 'transition-transform');
  });
  // 通知父组件更新数据
  updateFn();
}

function moveItem(fromIndex, toIndex) {
  const item = localList.value.splice(fromIndex, 1)[0];
  localList.value.splice(toIndex, 0, item);
}
const updateFn = () => {
  emit('update:list', JSON.parse(JSON.stringify(localList.value)));
  emit('update');
};
// function updateFn() {
//   this.$emit('update')
//   this.$emit('update:list', [...this.list]);
// }
// }
// }
</script>

<style scoped lang="scss">
.pre {
  color: #999 !important;
}
.zjanshi {
  fill: #333;
  &:hover {
    fill: #1fc069 !important;
  }
}
.yincang {
  fill: #999;
  &:hover {
    fill: #1fc069 !important;
  }
}

.souding {
  line-height: 60px;
  cursor: move;
  position: relative;
  top: 10px;
  margin-inline-end: 5px;
}

.drag-sort-container {
  display: flex;
  flex-direction: column;
}

.item {
  display: flex;
  line-height: 40px;
  box-sizing: border-box;
  color: #333333;
  font-size: 16px;
  border-bottom: 1px #eeeeee solid;

  .sort {
    padding-inline-end: 5px;
    box-sizing: border-box;
    cursor: move;
  }

  .zty-suoding {
    cursor: default;
    width: 0;
  }

  .label {
    flex: 1;
  }
  .icon {
    cursor: pointer;
    position: relative;
    top: 3px;
    &:hover {
      color: var(--color-1);
    }
  }
}

.dragging {
  z-index: 10;
}

.drag-ghost {
  opacity: 0.7;
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 过渡动画 */
.transition-transform {
  // transition: transform 0.3s;
  // transform: translateY(40px);
}

.no-transition {
  transition: none !important;
}

/* 元素交换位置时的动画效果 */
.drag-item:not(.drag-ghost):hover {
  // transform: translateX(5px);
}
</style>
